import React, { useEffect } from "react";
import css from "./PhotoVideo.module.scss";
import SecOne from "./SecOne/SecOne";
import SecTwo from "./SecTwo/SecTwo";
import SecThree from "./SecThree/SecThree";
import SecFour from "./SecFour/SecFour";
import { constants } from "assets/constants";
import { Helmet } from "react-helmet";

const PhotoVideo = () => {
    return (
        <div className={css.photoVideo}>
            <Helmet>
                <title>{constants.titles.services_photo_video}</title>
                <meta name="description" content={constants.descriptions.services_photo_video} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
            <SecFour />
        </div>
    );
};

export default PhotoVideo;
